import React from "react";
import {useDispatch, useSelector} from "react-redux";
import useOnClickOutside from "use-onclickoutside";

import * as actionTypes from "../../store/actions/actionTypes";
import EventLogs from "../EventLogs/EventLogs";
import loadingGif from "../../assets/images/loader.gif";

const ModalBookingEventLogs = () => {
    const dispatch = useDispatch();
    const {show, booking, logs, logs_eventTypes, loading} = useSelector(state => state.modal.bookingEventLogs);
    const ref = React.useRef(null);
    useOnClickOutside(ref, () => hideModal());

    const hideModal = () => dispatch({type: actionTypes.MODAL_BOOKING_EVENT_LOGS_HIDE});

    const renderBody = () => {
        if (loading) {
            return (
                <div className="text-center p-4">
                    <img src={loadingGif} alt="loading"/>
                </div>
            );
        }
        if (!logs || logs.length === 0) {
            return <p className="text-muted text-center p-4">No events for this booking yet.</p>;
        }
        return <EventLogs eventTypes={logs_eventTypes} logs={logs} />;
    }

    if (!show) return null;

    return (
        <div className={`modal fade ${show ? 'show' : ''}`} id="bookingEventLogsModal" tabIndex="-1" role="dialog" style={{display: 'block'}}>
            <div className="modal-dialog modal-lg modal-dialog-centered" role="document" ref={ref}>
                <div className="modal-content">
                    <div className="modal-header p-3">
                        <h5 className="modal-title h4">Activity for booking {booking.firstName} {booking.surname}</h5>
                        <button type="button" className="close" aria-label="Close" onClick={hideModal}>
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        {renderBody()}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalBookingEventLogs;
